<!-- 线条的动画 -->
<template>
  <div class="line-animation-container">
    <div class="line-animation-item">
      <div class="line-animation-label">动画效果</div>
      <div>
        <el-select
          v-model="chooseAnimate"
          size="mini"
          placeholder="请选择"
          value-key="name"
        >
          <el-option
            v-for="selectitem in AnimationList"
            :key="selectitem.type"
            :label="selectitem.name"
            :value="selectitem"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="line-animation-item">
      <div class="line-animation-label">颜色</div>
      <div>
        <el-color-picker
          v-model="color"
          size="mini"
          :show-alpha="true"
          :popper-class="'popper-color-prop'"
        ></el-color-picker>
      </div>
    </div>

    <div class="line-animation-item">
      <div class="line-animation-label">反向动画</div>
      <div>
        <el-switch
          v-model="reverse"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
    </div>

    <div class="line-animation-item">
      <div class="line-animation-label">动画速度</div>
      <div style="width: 50%">
        <el-slider v-model="speed" :min="1" :max="10"></el-slider>
      </div>
    </div>

    <div class="line-animation-item">
      <div class="line-animation-label">循环次数</div>
      <div>
        <el-input-number
          v-model="cycle"
          controls-position="right"
          :min="1"
          size="mini"
          :step="1"
          placeholder="默认无限循环"
        ></el-input-number>
      </div>
    </div>

    <div class="line-animation-item">
      <div class="line-animation-label">自动播放</div>
      <div>
        <el-switch
          v-model="autoPlay"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
    </div>

    <div class="line-animation-item">
      <div class="line-animation-label">保持最后状态</div>
      <div>
        <el-switch
          v-model="lastState"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
    </div>

    <div class="line-animation-item">
      <div class="line-animation-label">下一个动画</div>
      <div>
        <el-input
          v-model="nextAnimate"
          placeholder="下一个动画的tag标签"
          size="mini"
        ></el-input>
      </div>
    </div>

    <div class="animate-menus">
      <el-button
        type="primary"
        icon="el-icon-video-play"
        @click="changeState('play')"
        >播放</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-video-pause"
        @click="changeState('pause')"
        >暂停</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-circle-close"
        @click="changeState('stop')"
        >停止</el-button
      >
    </div>
  </div>
</template>
<script>
import AnimationList from "../../types/line-animation.js";
import { lineAnimationType } from "../../types/sprite-types";
export default {
  data() {
    return {
      AnimationList,
      lineAnimationType,
      chooseAnimate: null, //选择动画类型
      duration: 400, //动画时长
      cycle: Infinity, //循环次数
      color: "",
      reverse: false, //反向动画
      nextAnimate: "", //下一个动画的tag
      autoPlay: false, //是否自动播放动画
      lastState: false, //是否保持动画播放完成后的状态
      speed: 1,
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.init();
  },
  destroyed() {
    this.saveConfig();
    if(!this.chooseAnimate.type){
        this.topo.stageCanvas.stopAnimate(this.active.id);
    }
  },
  methods: {
    init() {
      if (this.topo.store && this.topo.store.active.length == 1) {
        this.active = this.topo.store.active[0];
      }

      if (!this.active) return;
      this.chooseAnimate = this.AnimationList.find(
        (item) => item.type == this.active.lineAnimateType
      );
      this.color = this.active.animateColor;
      this.speed = this.active.animateSpan || 1;
      this.reverse = this.active.animateReverse || false;
      this.cycle = this.active.animateCycle || Infinity;
      this.autoPlay = this.active.autoPlay || false;
      this.lastState = this.active.keepAnimateState || false;
      this.nextAnimate = this.active.nextAnimate;

    },

    saveConfig() {
      if (!this.active) return;
      this.active.lineAnimateType = this.chooseAnimate.type || '';
      this.active.animateColor = this.color;
      this.active.animateSpan = this.speed;
      this.active.animateReverse = this.reverse;
      this.active.animateCycle = this.cycle;
      this.active.autoPlay = this.autoPlay;
      this.active.keepAnimateState = this.lastState;
      this.active.nextAnimate = this.nextAnimate;

      this.topo.stageCanvas.setValue({
        id:this.active.id,
        animateColor:this.active.animateColor,
        animateSpan:this.active.animateSpan,
        animateReverse:this.active.animateReverse,
        animateCycle:this.active.animateCycle,
        autoPlay:this.active.autoPlay,
        keepAnimateState:this.active.keepAnimateState,
        nextAnimate:this.active.nextAnimate
      });
    },
    changeState(state) {
      if (!this.active) return;
      switch (state) {
        case "play":
          // 播放
          this.saveConfig()
          this.topo.stageCanvas.startAnimate(this.active.id);
          break;
        case "pause":
          this.topo.stageCanvas.pauseAnimate(this.active.id);
          break;
        case "stop":
          this.topo.stageCanvas.stopAnimate(this.active.id);
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.line-animation-container {
  .line-animation-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .line-animation-label {
      width: 120px;
    }
  }
  .animate-menus {
    display: flex;
    margin-top: 30px;
  }
}
</style>